export const FingerPointing = (props) => (
  <svg width="29px" height="42px" viewBox="0 0 29 42" {...props}>
    <g
      id="Features"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="feature---Dunning" transform="translate(-499.000000, -3466.000000)" strokeWidth="1.5">
        <g id="Group-6" transform="translate(240.000000, 3176.000000)">
          <g id="Group-52" transform="translate(0.000000, 95.000000)">
            <g id="Group-25">
              <g id="Group-24" transform="translate(260.000000, 196.000000)">
                <g id="3-right">
                  <path
                    d="M15.412,22 L15.412,13 C15.412,11.344 14.068,10 12.412,10 L12.412,10 C10.756,10 9.412,11.344 9.412,13 L9.412,18 L9.412,28 L5.348,26.646 C4.162,26.25 2.854,26.56 1.968,27.444 L1.968,27.444 C0.594,28.818 0.698,31.072 2.188,32.316 L10.298,39.074 C11.02,39.672 11.926,40 12.86,40 L21.88,40 C23.898,40 25.598,38.498 25.85,36.496 L26.936,27.81 C27.202,25.68 25.74,23.722 23.624,23.368 L15.412,22 L15.412,22 Z"
                    id="Path"
                    stroke="currentColor"
                  />
                  <line x1="0.42" y1="12" x2="2.42" y2="12" id="Path" stroke="currentColor" />
                  <line x1="24.42" y1="12" x2="22.42" y2="12" id="Path" stroke="currentColor" />
                  <line x1="20.9" y1="3.52" x2="19.48" y2="4.92" id="Path" stroke="currentColor" />
                  <line x1="3.92" y1="3.52" x2="5.34" y2="4.92" id="Path" stroke="currentColor" />
                  <line x1="12.42" y1="0" x2="12.42" y2="2" id="Path" stroke="currentColor" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
